import React from 'react';

const BetaLabsRequiredMessage: React.FC = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="text-center p-4">
        <div 
          className="mb-3"
          style={{ fontSize: '64px', color: '#6c757d' }}
        >
          🧪
        </div>
        <h3 className="mb-3">Beta Labs Feature</h3>
        <p className="text-muted mb-4">
          This feature is part of our Beta Labs program. To access it, please enable Beta Labs 
          in the information menu (i icon) at the top right of the page.
        </p>
        <div className="alert alert-info">
          <strong>What is Beta Labs?</strong><br/>
          Beta Labs gives you early access to experimental features that are still in development. 
          These features may change or be removed in future updates.
        </div>
      </div>
    </div>
  );
};

export default BetaLabsRequiredMessage;
